/**
 * UX Utilities for consistent user experience patterns
 */

import DataService from '../../_services/DataService';

/**
 * Alert display duration in milliseconds
 */
export const ALERT_TIMEOUT_MS = 5.5 * 1000;

/**
 * Get client preferences and update component data
 * @param {Object} vueInstance - Vue component instance (this)
 * @returns {Promise} - Resolves after attempting to load preferences
 */
export async function loadClientPreferences(vueInstance) {
  const response = await DataService.getClientPreferences();
  if (response.status === 200) {
    vueInstance.clientLogo = response.data.clientLogo;
    vueInstance.clientColor = response.data.clientColor;
    vueInstance.whiteBehindLogo = response.data.whiteBehindLogo;
  }
}
